import { arrival, lend } from "../client";
const config = {
  headers: {},
  signal: null,
};

export const addNewArrival = (params) => {
    const user = {
      flag: "addLibraryBook",
      parameters: {
        libraryBooks: params,
  
      },
    };
    return arrival.post("/library/add/book", user);
  };

  export const getNewArrival = (params) => {
    const user = {
      flag: "getLibraryBook",
      parameters: {
        libraryBooks: params,
  
      },
    };
    return arrival.post("/library/get/books", user);
  };  

  export const updateArrival = (params) => {
    const user = {
      flag: "updateLibraryBook",
      parameters: {
        libraryBooks: params,
  
      },
    };
    return arrival.post("/library/update/book", user);
  }; 

  export const deleteArrival = (params) => {
    const user = {
      flag: "deleteLibraryBook",
      parameters: {
        libraryBooks: params.libraryBooks,
  
      },
    };
    return arrival.delete("/library/delete/book",  { data: user });
  }; 

/*

  "name": "Akash Medical College",

            "address": "vellore",

            "emailId": "akashguna99@gmail.com",

            "mobileNumber": "6379091283"
*/